/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseUpdateReqVo
 */
export interface WarehouseUpdateReqVo {
    /**
     * 仓库类型 1=自营 2=代理
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    warehouseType?: number;
    /**
     * 仓库名称（韩文）
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    name?: string;
    /**
     * 仓库中文名称
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    nameCn?: string;
    /**
     * 国家ID
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    nationId?: number;
    /**
     * 仓库编码
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    code?: string;
    /**
     * 代理编号（代理仓库填写）
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    warehouseProxyCode?: string;
    /**
     * 纸箱唛头号前缀
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    boxMarknoPrefix?: string;
    /**
     * 托盘唛头号前缀
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    palletMarknoPrefix?: string;
    /**
     * 邮政编码
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    zip?: string;
    /**
     * 关联海外仓ID（代理仓库填写）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    connectWarehouseId?: number;
    /**
     * 城市
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    city?: string;
    /**
     * 省/州
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    state?: string;
    /**
     * 地址
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    address?: string;
    /**
     * 详细地址
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    addressDetail?: string;
    /**
     * 地址（英文）
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    addressEn?: string;
    /**
     * 详细地址（英文）
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    addressDetailEn?: string;
    /**
     * 联系方式
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    mobileNo?: string;
    /**
     * 联系人姓名
     * @type {string}
     * @memberof WarehouseUpdateReqVo
     */
    contactName?: string;
    /**
     * 入库方式 1=快递 2=唛头 3=入库证（多选）
     * @type {Array<number>}
     * @memberof WarehouseUpdateReqVo
     */
    receivingMethod?: Array<number>;
    /**
     * COUPANG中转 0=否 1=是
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    transshipment?: number;
    /**
     * 3PL功能 1=仓储 2=一件代发（多选）
     * @type {Array<number>}
     * @memberof WarehouseUpdateReqVo
     */
    warehouseFunction?: Array<number>;
    /**
     * 一件代发预支费用（韩币）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    dropshippingFee?: number;
    /**
     * 免仓储费时限（天）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    freeStorageDays?: number;
    /**
     * 橙火订单免仓储费时限（天）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    rocketOrderFreeStorageDays?: number;
    /**
     * 仓储费单价（1CBM/1Day，韩币）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    storageFeeUnit?: number;
    /**
     * 纸箱卸货费单价（韩币）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    boxUnloadingFeeUnit?: number;
    /**
     * 托盘卸货费单价（韩币）
     * @type {number}
     * @memberof WarehouseUpdateReqVo
     */
    palletUnloadingFeeUnit?: number;
    /**
     * 支持的运输方式ID列表
     * @type {Array<number>}
     * @memberof WarehouseUpdateReqVo
     */
    transportMethodIds?: Array<number>;
}

/**
 * Check if a given object implements the WarehouseUpdateReqVo interface.
 */
export function instanceOfWarehouseUpdateReqVo(value: object): value is WarehouseUpdateReqVo {
    return true;
}

export function WarehouseUpdateReqVoFromJSON(json: any): WarehouseUpdateReqVo {
    return WarehouseUpdateReqVoFromJSONTyped(json, false);
}

export function WarehouseUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseType': json['warehouseType'] == null ? undefined : json['warehouseType'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'code': json['code'] == null ? undefined : json['code'],
        'warehouseProxyCode': json['warehouseProxyCode'] == null ? undefined : json['warehouseProxyCode'],
        'boxMarknoPrefix': json['boxMarknoPrefix'] == null ? undefined : json['boxMarknoPrefix'],
        'palletMarknoPrefix': json['palletMarknoPrefix'] == null ? undefined : json['palletMarknoPrefix'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'connectWarehouseId': json['connectWarehouseId'] == null ? undefined : json['connectWarehouseId'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'addressEn': json['addressEn'] == null ? undefined : json['addressEn'],
        'addressDetailEn': json['addressDetailEn'] == null ? undefined : json['addressDetailEn'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'contactName': json['contactName'] == null ? undefined : json['contactName'],
        'receivingMethod': json['receivingMethod'] == null ? undefined : json['receivingMethod'],
        'transshipment': json['transshipment'] == null ? undefined : json['transshipment'],
        'warehouseFunction': json['warehouseFunction'] == null ? undefined : json['warehouseFunction'],
        'dropshippingFee': json['dropshippingFee'] == null ? undefined : json['dropshippingFee'],
        'freeStorageDays': json['freeStorageDays'] == null ? undefined : json['freeStorageDays'],
        'rocketOrderFreeStorageDays': json['rocketOrderFreeStorageDays'] == null ? undefined : json['rocketOrderFreeStorageDays'],
        'storageFeeUnit': json['storageFeeUnit'] == null ? undefined : json['storageFeeUnit'],
        'boxUnloadingFeeUnit': json['boxUnloadingFeeUnit'] == null ? undefined : json['boxUnloadingFeeUnit'],
        'palletUnloadingFeeUnit': json['palletUnloadingFeeUnit'] == null ? undefined : json['palletUnloadingFeeUnit'],
        'transportMethodIds': json['transportMethodIds'] == null ? undefined : json['transportMethodIds'],
    };
}

export function WarehouseUpdateReqVoToJSON(json: any): WarehouseUpdateReqVo {
    return WarehouseUpdateReqVoToJSONTyped(json, false);
}

export function WarehouseUpdateReqVoToJSONTyped(value?: WarehouseUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseType': value['warehouseType'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'nationId': value['nationId'],
        'code': value['code'],
        'warehouseProxyCode': value['warehouseProxyCode'],
        'boxMarknoPrefix': value['boxMarknoPrefix'],
        'palletMarknoPrefix': value['palletMarknoPrefix'],
        'zip': value['zip'],
        'connectWarehouseId': value['connectWarehouseId'],
        'city': value['city'],
        'state': value['state'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'addressEn': value['addressEn'],
        'addressDetailEn': value['addressDetailEn'],
        'mobileNo': value['mobileNo'],
        'contactName': value['contactName'],
        'receivingMethod': value['receivingMethod'],
        'transshipment': value['transshipment'],
        'warehouseFunction': value['warehouseFunction'],
        'dropshippingFee': value['dropshippingFee'],
        'freeStorageDays': value['freeStorageDays'],
        'rocketOrderFreeStorageDays': value['rocketOrderFreeStorageDays'],
        'storageFeeUnit': value['storageFeeUnit'],
        'boxUnloadingFeeUnit': value['boxUnloadingFeeUnit'],
        'palletUnloadingFeeUnit': value['palletUnloadingFeeUnit'],
        'transportMethodIds': value['transportMethodIds'],
    };
}

